
export default {
    props: {
        title: {
            type: String,
            required: false,
            default: () => 'Resumen de la reserva'
        },
        totalPrice: {
            type: Number,
            required: false,
            default:() => 0
        },
        extras: {
            type: String,
            required: false,
            default:() => ''
        },
        items: [
            {
                icon: {
                    type: String,
                    required: true,
                    default: () => ''
                },
                label: {
                    type: String,
                    required: true,
                    default: () => 'Item title'
                }
            }
        ]
    },
    // TODO: borrar esto cuando este integrado
    data() {
        return {
            localItems: this.items,
            personPrice: this.totalPrice,
            togetherPrice: this.totalPrice,
            localPrice: this.totalPrice,
            localExtras: this.extras
        }
    },
    created() {
        this.localItems = [
            {
                icon: '/img/icons/airplane.svg',
                label: 'Desde Barcelona'
            },
            {
                icon: '/img/icons/user.svg',
                label: '2 personas'
            },
            {
                icon: '/img/icons/calendar.svg',
                label: '17/01/2020'
            },
            {
                icon: '/img/icons/location.svg',
                label: 'Desde Barcelona'
            }
        ];
        this.personPrice = 100;
        this.togetherPrice = 6.96;
        this.localPrice = 106.96;
        this.localExtras = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et.';
    },
}
